import { lightTheme } from "@/theme/themes";
import { Platform, Pressable, Text, View } from "react-native";

/**
 * Fallback der Root-Boundary. Nur „Neu laden“, ohne Auth und ohne Query.
 */
export function RootReloadFallback({ resetError }: { resetError: () => void }) {
  const reload = () => {
    const loc = globalThis.location as { reload?: () => void } | undefined;
    if (typeof loc?.reload === "function") {
      loc.reload();
      return;
    }
    resetError();
  };

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        padding: lightTheme.space.xl,
        backgroundColor: lightTheme.color.bg,
      }}
      {...(Platform.OS === "web" ? { dataSet: { fcShell: "1" } } : {})}
    >
      <Text
        accessibilityRole="header"
        style={{
          color: lightTheme.color.text,
          fontSize: lightTheme.fontSize.title,
          fontWeight: "700",
          marginBottom: lightTheme.space.lg,
        }}
      >
        Etwas ist schiefgelaufen.
      </Text>
      <Pressable
        accessibilityRole="button"
        onPress={reload}
        style={{ minHeight: 44, justifyContent: "center", paddingHorizontal: lightTheme.space.lg }}
      >
        <Text style={{ color: lightTheme.color.primary, fontWeight: "700" }}>Neu laden</Text>
      </Pressable>
    </View>
  );
}
